export const APIEndpointBase = "https://qa.api.lims.mirimus.com";
